class InlinePromoTimer extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
    this.remaining = 0;
    this.mode = "countdown"; // default
  }

  connectedCallback() {
    this.initializeTimer();
    this.render();
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  static get observedAttributes() {
    return ["time", "deadline"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;

    this.initializeTimer();
    this.render();
    this.start();
  }

  initializeTimer() {
    const deadlineAttr = this.getAttribute("deadline");

    if (deadlineAttr) {
      const deadlineDate = new Date(deadlineAttr);

      if (!isNaN(deadlineDate.getTime())) {
        this.mode = "deadline";
        this.deadline = deadlineDate;
        this.updateDeadlineRemaining();
        return;
      } else {
        console.error("[InlinePromoTimer] invalid deadline:", deadlineAttr);
      }
    }

   
    const timeAttr = this.getAttribute("time") || "00:00:00";
    this.mode = "countdown";
    this.remaining = this.parseTime(timeAttr);
  }

  parseTime(str) {
    const parts = str.split(":");
    if (parts.length !== 3) return 0;
    const [h, m, s] = parts.map(Number);
    return (h * 3600) + (m * 60) + (s || 0);
  }

  updateDeadlineRemaining() {
    const now = new Date();
    const diff = Math.floor((this.deadline - now) / 1000);
    this.remaining = Math.max(0, diff);
  }

format(seconds) {
  const days = Math.floor(seconds / 86400);     
  const hours = Math.floor((seconds % 86400) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (days <= 0) {
    return (
      String(hours).padStart(2, "0") + ":" +
      String(minutes).padStart(2, "0") + ":" +
      String(secs).padStart(2, "0")
    );
  }

  return (
    days + ":" +
    String(hours).padStart(2, "0") + ":" +
    String(minutes).padStart(2, "0") + ":" +
    String(secs).padStart(2, "0")
  );
}


  start() {
    this.stop(); 

    this.interval = setInterval(() => {
      if (this.mode === "deadline") {
        this.updateDeadlineRemaining();
      } else if (this.mode === "countdown") {
        this.remaining--;
      }

      if (this.remaining <= 0) {
        this.remaining = 0;
        this.render();
        this.stop();
        return;
      }

      this.render();
    }, 1000);
  }

  stop() {
    if (this.interval) clearInterval(this.interval);
    this.interval = null;
  }

  render() {
    this.innerHTML = `
      <p class="inline-timer">${this.format(this.remaining)}</p>
    `;
  }
}

customElements.define("inline-promo-timer", InlinePromoTimer);
